import React from 'react';
import cn from 'classnames';

const Container = props => (
  <div css={styles.container} className={cn('ph3', 'ph0-l', props.className)}>
    {props.children}
  </div>
);

export default Container;

const styles = {
  container: {
    width: '100%',
    maxWidth: '960px',
    margin: '0 auto',
  },
};



// WEBPACK FOOTER //
// ./src/components/Container.js